export default __webpack_public_path__ + "static/media/arrow-down.58223b02.svg";